<template>
  <div :id="chartId" :class="['sw-chart', `${isDarkTheme}?'sw-chart--dark':''`]"
    style="width: 100%; height: 300px;">
    Chart Area
  </div>
</template>
<style lang="scss">
  .sw-chart--dark {
    background-color: #222;
  }
</style>

<script lang="js">
require('amcharts3/amcharts');
require('amcharts3/serial');
require('amcharts3/pie');
require('amcharts3/themes/dark');
require('amcharts3/themes/light');

const defaultConfig = {
  type: 'serial',
  accessibleTitle: 'chart denotes data.',
  labelsEnabled: false,
  // baseColor: '#00b6a3',
  // borderAlpha: .9, // rect border of chart container.
  hoverAlpha: 0.8,
  outlineAlpha: 0.6,
  startDuration: 0,
  pullOutDuration: .3,
  pullOutOnlyOne: true,
  colors: ['#00b6a3', '#d38abd', '#ffa451', '#f30b76', '#767cb4', '#27aee6', '#b8db76', '#ff4533'],
};

const defaultGraphOpts = {
  // type: 'line' | 'column',
  title: '',
  valueField: 'value',
  fillAlphas: 0.15,
  lineThickness: 2,
  bullet: 'round',
  cornerRadiusTop: 3,
};

const defaultPieOpts = {
  type: 'pie',
  valueField: 'value',
  balloon: {
    enabled: false,
  },
  pullOutRadius: '6%',
};

export default {
  props: {
    chartId: {
      type: String,
      default: 'chartdiv',
    },
    chartConfig: {
      type: Object,  // consider redefine a type.
      default: defaultConfig,
    },
    chartData: {
      type: Array,
    },
    value: {
      type: Number,
      default: -1,
    },
    // theme string should be props..
  },
  data () {
    return {
      chart: null,
      isDarkTheme: false,
      theme: 'light',
      textColor: '#222',
      selectedSlice: this.value,
    };
  },

  mounted() {
    this.initChart();
  },

  beforeDestroy() {
    // remove all listener..
    if (this.chart !== null && this.isPiechart) {
      this.removePieListener();
    }
  },

  computed: {
    isPiechart() {
      return this.chartConfig.type === 'pie' || this.chartConfig.type === 'donut';
    },
    isSerial() {
      return this.chartConfig.type === 'line' || this.chartConfig.type === 'column';
    },
  },

  methods: {
    initChart() {
      let customOpt = {};
      console.warn('initialing chart.. debug..');
      if (this.isSerial) {
        const serialCustomOpt = {
          type: 'serial',
          chartCursor: {},
          dataProvider: this.chartData,
          categoryField: this.chartConfig.categoryField,
          graphs: [Object.assign({}, defaultGraphOpts, this.chartConfig)],
        };
        customOpt = Object.assign({}, defaultConfig, serialCustomOpt, { theme: this.theme, color: this.textColor });
      } else if (this.chartConfig.type === 'pie') {
        const pieCustomOpt = Object.assign({ dataProvider: this.chartData }, defaultPieOpts, this.chartConfig);
        customOpt = Object.assign({}, defaultConfig, pieCustomOpt, { theme: this.theme, color: this.textColor });
      } else if (this.chartConfig.type === 'donut') {
        const pieCustomOpt = Object.assign({}, defaultPieOpts, { innerRadius: 70, dataProvider: this.chartData }, this.chartConfig);
        customOpt = Object.assign({}, defaultConfig, pieCustomOpt, { type: 'pie', theme: this.theme, color: this.textColor });
      }

      this.chart = AmCharts.makeChart(this.chartId, customOpt);
      if (this.isPiechart && this.chart !== null) {
        this.addPieListener();
      }
    },

    addPieListener() {
      // pieChart.addTitle('Event Types Chart');
      this.chart.addListener('rollOverSlice', this.handleRollOver);
      this.chart.addListener('rollOutSlice', this.handleRollOut);
    },

    removePieListener() {
      this.chart.removeListener('rollOverSlice', this.handleRollOver);
      this.chart.removeListener('rollOutSlice', this.handleRollOut);
    },

    handleRollOver(data) {
      const dataItem = data.dataItem;
      this.selectedSlice = dataItem.index;
      this.chart.clickSlice(dataItem.index);
      this.chart.clearLabels();
      // this label trick depends on chartDiv height/2.
      this.chart.addLabel(0, 130, `${dataItem.title}`, 'center', 14);
      this.chart.addLabel(0, 160, `${dataItem.value} events`, 'center', 14);
      this.$emit('change', this.selectedSlice);
    },

    handleRollOut(data) {
      const dataItem = data.dataItem;
      this.selectedSlice = -1;
      this.chart.clickSlice(dataItem.index);
      this.chart.clearLabels();
      this.$emit('change', this.selectedSlice);
    },

    // isDarkTheme value is toggled.
    handleTheme(isDark) {
      this.theme = isDark ? 'dark' : 'light';
      this.textColor = isDark ? '#fff' : '#222';
      AmCharts.theme = isDark ? 'dark' : 'light';
    },
  },
};
</script>
